import { FetchJson } from './Fetch';

const liveAPI = {
    getTimeSetting:() => FetchJson.get( `/live/time-settings`),
    getRequestData:(data) => FetchJson.get('/live',data),
    putTimeSetting:(data:any) => FetchJson.put('/live/time-settings', data),
    putLiveReply:(id, data:any) => FetchJson.put(`/live/${id}/reply`, data),
    putSendRecode:(id, data:any) => FetchJson.put(`/live/${id}/send-record`, data),
}

export { liveAPI };